import { ref, readonly } from "vue"

// Single source of truth for the page-load overlay. Writes happen in one place:
// App.vue wires setPending/setReady to <Suspense>'s @pending/@resolve events, so
// pageReady flips false the moment a new async view mounts and true once its
// top-level awaits resolve. Everything else only reads pageReady.
const pageReady = ref(true)

// Scroll is deferred until the page is ready: the router's scrollBehavior records the
// intended position per navigation (top for forward nav, saved coords for back/forward),
// and setReady applies it once the incoming view's awaits resolve — so the viewport jumps
// only after the new content is in, not on the bare route change.
type ScrollTarget = { top: number; left?: number }
let pendingScroll: ScrollTarget | null = { top: 0 }

export function recordScroll(saved: ScrollTarget | null) {
  pendingScroll = saved ?? { top: 0 }
}

export function usePageReady() {
  return {
    pageReady: readonly(pageReady),
    setPending: () => (pageReady.value = false),
    setReady: () => {
      pageReady.value = true
      if (pendingScroll && typeof window !== "undefined") {
        window.scrollTo(pendingScroll)
        pendingScroll = null
      }
    },
  }
}
